export default "January 30, 2023";